// extracted by css-extract-rspack-plugin
export default {"languageCircle":"LanguageCircle-module__languageCircle__LQ6b4"};